import React from 'react';
import InfoBlock from '../../../../components/InfoBlock/InfoBlock';
import Info from './components/Info';
import TenantBlock from './components/TenantBlock';
import Owners from './components/Owners';
import Services from './components/Services';
import BadgeBlock from './components/BadgeBlock';
import { upperCaseFirst } from '../../../../../../helpers/upperCaseFirst';

const RoomBlock = ({ room }) => {
  return (
    <InfoBlock
      title="Помещение"
      action={
        room?.status?.id === 1 ? (
          <BadgeBlock status={upperCaseFirst(room.status.name)} />
        ) : undefined
      }
    >
      <Info room={room} />
      <TenantBlock room={room} />
      <Owners room={room} />
      <Services room={room} />
    </InfoBlock>
  );
};

export default RoomBlock;
